/**
 * Creates an empty i18n object from a supportedLanguages array.
 * First language gets defaultValue; others get empty string.
 */
export const createI18nObject = (languages, defaultValue = '') =>
  Object.fromEntries(languages.map((lang, i) => [lang, i === 0 ? defaultValue : '']));

/**
 * Returns a human-readable label for a language code.
 * e.g. 'pt_BR' → 'PT-BR', 'en' → 'EN'
 */
export const getLangLabel = (code) => code.replace('_', '-').toUpperCase();

/**
 * Returns the default (first) language code.
 */
export const getDefaultLang = (languages) => languages[0];

/**
 * Safely resolves a name value that may be a plain string or an i18n object
 * (e.g. { pt: 'PLA', en: 'PLA' } or the legacy { default: 'PLA' } shape).
 * Returns the first truthy value found, or an empty string.
 */
export const getDisplayName = (name) => {
  if (!name) return '';
  if (typeof name === 'string') return name;
  if (typeof name === 'object') {
    const values = Object.values(name);
    return values.find((v) => v) || '';
  }
  return String(name);
};
